import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="value-fetcher"
export default class extends Controller {
  static values = { url: String }
  static targets = ["spinner"]

  fetch(event) {
    event.preventDefault()

    if (!this.hasUrlValue) {
      return
    }

    this.spinnerTarget.classList.remove("hidden")
    
    fetch(this.urlValue)
      .then(response => response.text())
      .then(html => {
        this.element.insertAdjacentHTML("afterend", html)
      }).then(() => {
        this.urlValue = undefined
        this.spinnerTarget.classList.add("hidden")
        this.dispatch("loadend")
      });
  }
}
